import React from 'react';
import Banner from '../components/Banner';
import WelcomeSection from '../components/WelcomeSection';
import WhyChooseUs from '../components/WhyChooseUs';
import FeaturedRooms from '../components/FeaturedRooms';
import ContactInfo from '../components/ContactInfo';

const Home = () => {
  return (
    <>
      <Banner />
      <WelcomeSection />
      <WhyChooseUs />
      <FeaturedRooms />
      <ContactInfo />
    </>
  );
};

export default Home;